import React from 'react'
import { Media } from '~/models'
import { ImageView, VideoView } from '~/ui/app/media'
import { memo } from '~/ui/component'
import { Center, ClearButton, VBox } from '~/ui/components'
import { useResourceTranslation } from '~/ui/resources'
import { colors, createUseStyles, layout, ThemeProvider } from '~/ui/styling'

export interface Props {
  media: Media
  requestRemove?: (id: string) => any
}

const PostMediaThumbnail = memo('PostMediaThumbnail', (props: Props) => {

  const {media, requestRemove} = props

  const {t} = useResourceTranslation('posts')

  const remove = React.useCallback(() => {
    requestRemove?.(media.id)
  }, [media, requestRemove])

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <VBox flex classNames={$.PostMediaThumbnail} >
        {renderMedia()}
        {requestRemove != null && (
          <Center classNames={$.remove}>
            <ThemeProvider dark>
              <ClearButton
                icon='cross'
                caption={t('post_form.remove_media')}
                onTap={remove}
                padding='horizontal'
                small
              />
            </ThemeProvider>
          </Center>
        )}
      </VBox>
    )
  }

  function renderMedia() {
    if (/^image\//.test(media.contentType)) {
      return (
        <ImageView
          source={media.url}
          flex
        />
      )
    } else {
      return (
        <VideoView
          source={media.url}
          flex
          overlay
        />
      )
    }
  }

  return render()

})

export default PostMediaThumbnail

const useStyles = createUseStyles({
  PostMediaThumbnail: {
    position: 'relative',
  },

  remove: {
    position:   'absolute',
    bottom:     0,
    left:       0,
    right:      0,
    padding:    [layout.padding.inline.s, layout.padding.inline.m],
    background: colors.shim.dark,
  },
})